export default class AttachmentInstall {
  public id = '';

  public name = '';

  public path = '';

  constructor(data: any = {}) {
    this.id = data.id || '';
    this.name = data.name || '';
    this.path = data.path || '';
  }
}
